import { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message,Modal } from "antd";
import { produce } from "immer";
import {
  selectDayOrders,
  getOrderDetails,
  getOrderStats,
  selectNewOrders,
  // selectLocations,
  selectStatistics,
  selectLoaded,
  getMonitorOrders,
  acceptMonitorOrder,
  updateMonitorOrder,
  dispatchMonitorOrder,
  assignMonitorDriver,
  finishMonitorOrder,
  cancelMonitorOrder,
  resendCirebaOrder,
  sendPeyaOrder,
  // deliveryLocation,
  getBranchDrivers,
  transferMonitorOrder,
  // updateNotesClient,
  setLoaded,
} from "../../redux/slices/monitor";
import { selectUser } from "../../redux/slices/user";
import { getAllBranches, selectBranches } from "../../redux/slices/branches";
import NewMonitorUI from "./components/NewMonitorUI";
import { cancellationReasonListThunk, selectCancellationReasons } from "../../redux/slices/cancellationReason";
const Monitor = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [tableFilters, setTableFilters] = useState({});
  const [loadingTable, setLoadingTable] = useState(false);
  const filtersRef = useRef({});
  const [modalOrder, handleModalOrder] = useState(false);
  // const [modalCommentaries, handleModalCommentaries] = useState(false);
  const [loadingOrder, handleLoadingOrder] = useState(false);
  const [modalDriverConfirm, handleModalDriverConfirm] = useState(false);
  const [orderDetail, handleOrderDetail] = useState({});
  const lastOrder =  useRef(null)
  const newOrders = useSelector(selectNewOrders);
  const dayOrders = useSelector(selectDayOrders);
  const branches = useSelector(selectBranches);
  const statistics = useSelector(selectStatistics);
  const reasons = useSelector(selectCancellationReasons)
  const loaded = useSelector(selectLoaded);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const initialFetchs = useCallback(async (page = 1, filters = {}) => {
    const branches = await dispatch(getAllBranches(null, true));
    const [response] = await Promise.all([
      dispatch(getMonitorOrders(user.branch, user.admin, page, filters)),
      dispatch(getOrderStats(user.branch, user.admin)),
      dispatch(cancellationReasonListThunk())
      // dispatch(getPromosListThunk()) // para mostrar las promos dia del nino
    ]);
    if (response.status === "success") {
      console.log("000",response)
      setOrdersTotal(response.total || 0);
    } else {
      message.error("Hubo un problema");
    }
  }, [dispatch, user]);

  const initialFetch = useCallback(async (page = 1, filters = {}) => {
    await dispatch(getAllBranches(null, true));

    const [response] = await Promise.all([
      dispatch(getMonitorOrders(user.branch, user.admin, page, filters)),
      dispatch(getOrderStats(user.branch, user.admin)),
      dispatch(cancellationReasonListThunk()),
    ]);

    if (response.status === "success") {
      const totalItems = response.total || 0;
      const currentPageItemCount = response.orders?.length || 0;
      const lastPage = Math.ceil(totalItems / 10);

      if (page > lastPage && lastPage > 0) {
        setCurrentPage(lastPage);
        await initialFetch(lastPage, filters); // reintenta con la última válida
        return;
      }

      setOrdersTotal(totalItems);
    } else {
      message.error("Hubo un problema");
    }
  }, [dispatch, user]);

  
  useEffect(() => {
    const getEverything = async () => {
      await initialFetch(currentPage, tableFilters);
      dispatch(setLoaded(true));
    };
    getEverything();
  }, [dispatch, initialFetch]);


  useEffect(() => {
    const countup = setInterval(() => {
      initialFetch(currentPage, tableFilters);
    }, 30000);

    return () => {
      clearInterval(countup);
    };
  }, [initialFetch, currentPage, tableFilters]);


  const openDetails = async (order) => {
    handleLoadingOrder(order);
    const response = await dispatch(getOrderDetails(order));
    handleLoadingOrder(false);
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      handleOrderDetail(response.order);
      handleModalOrder(true);
    }
  };

  const closeDetails = () => {
    handleModalOrder(false);
    handleOrderDetail({});
  };

  const updateOrderStatus = (status) => {
    const newOrder = produce(orderDetail, (draftState) => {
      draftState.status = status;
    });
    handleOrderDetail(newOrder);
  };

  const openDriverConfirm = (order) => {
    handleModalDriverConfirm(true);
  };

  const closeDriverConfirm = () => {
    handleModalDriverConfirm(false);
    handleModalOrder(true);
  };

  const acceptOrder = async () => {
    const response = await dispatch(
      acceptMonitorOrder(orderDetail.id, user.branch)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(7);
      message.success("Orden en preparación");
    }
  };

  const updateOrder = async () => {
    if(orderDetail.orderType == 2) {
      const response = await dispatch(dispatchMonitorOrder(orderDetail.id));
      if (response.status !== "success") {
        message.error("Hubo un problema");
      } 
      else {
        updateOrderStatus(10);
        message.success("Orden lista para el driver");
      }
    } 
    else {
      const response = await dispatch(updateMonitorOrder(orderDetail.id));
      if (response.status !== "success") {
        message.error("Hubo un problema");
      } 
      else {
        updateOrderStatus(11);
        message.success("Orden lista para recoger");
      }
    }
  };

  const assignOrder = async (driver, force) => {
    let response = null;
    if(force) {
      response = await dispatch(assignMonitorDriver(orderDetail.id, driver, force));
    } else {
      response = await dispatch(assignMonitorDriver(orderDetail.id, driver));
    }

    console.log('asignado y respuesta');
    if (response.status !== "success") {
      if(response.status == "warning") {
        Modal.confirm({
          title: 'Cambio de driver detectado',
          content: `¿Deseas cambiar el driver actual ${response.driver.name}?`,
          okText: 'Confirmar',
          cancelText: 'Cancelar',
          onOk: () => assignOrder(driver, true), // llamada con forzarCambio = true
        });
      } 
      else {
        message.error("Hubo un problema");
      }
    } else {
      //handleOrderDetail(response.order);
      //await initialFetch();
      //updateOrderStatus(10);
      handleOrderDetail(response.order);
      message.success("Orden asignada");
    }
  };

 
  const transferOrder = async (branch, reason) => {
    const response = await dispatch(
      transferMonitorOrder(orderDetail.id, branch, user.id, reason)
    );
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } 
    else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(7);
      message.success("Orden transferida");
    }
  };

  const finishOrder = async () => {
    const response = await dispatch(finishMonitorOrder(orderDetail.id));
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(12);
      message.success("Orden finalizada");
      closeDetails(); // cerrar modal
      await initialFetch(currentPage, tableFilters); 
      // closeModalCommetaries();
    }
  };

  const cancelOrder = async (user, reason) => {
    const response = await dispatch(cancelMonitorOrder(orderDetail.id, user, reason));
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } else {
      // handleOrderDetail(response.order);
      // await initialFetch();
      updateOrderStatus(15);
      message.success("Orden cancelada");
      closeDetails();
      await initialFetch(currentPage, tableFilters); 
      // closeModalCommetaries();
    }
  };

  const resendOrder = async () => {
    const response = await dispatch(resendCirebaOrder(orderDetail.id, orderDetail.branch.id));
    if (response.status !== "success") {
      message.error("Hubo un problema reenviando la orden");
      return;
    }
    handleOrderDetail(response.order);
    const { cireba_remote_id } = response.order;
    if (cireba_remote_id && cireba_remote_id !== "0") {
      message.success("Orden ingresada a CIREBA correctamente");
    } else {
      message.error("CIREBA rechazo la orden nuevamente");
    }
  };

  const sendPeya = async () => {
    message.info("Enviando Solicitud a pedidos ya");
    const response = await dispatch(sendPeyaOrder(orderDetail.id, orderDetail.branch.id));
    if (response.status !== "success") {
      message.error("Hubo un problema");
    } 
    else {
      message.success("Orden enviada a Pedidos Ya");
      // closeModalCommetaries();
    }
  }

  const getDriversBranch = async (location, order) => {
    const response = await dispatch(getBranchDrivers(location, order));
    if (response.status !== "success") {
      message.error("Hubo un problema");
      return [];
    }
    return response.drivers;
  };



/*
  const handleDelivery = async (idBranch, index, val) => {
    const response = await dispatch(deliveryLocation(idBranch, index, val));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  }; 
*/

  const isAdmin = user.admin;
  const isDriver = user.driver;
  const playSound = () => {
    const audio = new Audio('/sounds/order-notification.mp3')
    audio.onerror = (e) => {
        console.error('Error al cargar el audio:', e);
    };
    audio.play().catch((error) => {
        console.error('Error al reproducir el audio:', error);
    });
  };
  const alertNewOrder = () => { 
    if(newOrders.length > 0){
      const order = newOrders[0]
      const last = lastOrder.current
      if(order.created_time !== last?.created_time && [1,2].includes(order.orderType)){
        playSound()
        lastOrder.current = newOrders[0]
      }
    }
  }
  
  useEffect(() => {
    alertNewOrder()
  }, [newOrders])
  
  return (
    <>
    {/* <MonitorUI
      modalOrder={modalOrder}
      openDetails={openDetails}
      loadingOrder={loadingOrder}
      newOrders={newOrders}
      dayOrders={dayOrders}
      statistics={statistics}
      // branches={branches}
      loaded={loaded}
      user={user}
      isAdmin={isAdmin}
      isDriver={isDriver}
      orderDetail={orderDetail}
      acceptOrder={acceptOrder}
      updateOrder={updateOrder}
      assignOrder={assignOrder}
      finishOrder={finishOrder}
      cancelOrder={cancelOrder}
      resendOrder={resendOrder}
      sendPeya={sendPeya}
      closeDetails={closeDetails}
      getDriversBranch={getDriversBranch}
      openDriverConfirm={openDriverConfirm}
      // openModalCommetaries={openModalCommetaries}
      // closeModalCommetaries={closeModalCommetaries}
      // modalCommentaries={modalCommentaries}
      // transferOrder={transferOrder}
      // updateNotes={updateNotes}
    /> */}
    <NewMonitorUI
    modalOrder={modalOrder}
    openDetails={openDetails}
    loadingOrder={loadingOrder}
    newOrders={newOrders}
    dayOrders={dayOrders}
    statistics={statistics}
    branches={branches}
    loaded={loaded}
    user={user}
    isAdmin={isAdmin}
    isDriver={isDriver}
    orderDetail={orderDetail}
    acceptOrder={acceptOrder}
    updateOrder={updateOrder}
    assignOrder={assignOrder}
    finishOrder={finishOrder}
    cancelOrder={cancelOrder}
    resendOrder={resendOrder}
    sendPeya={sendPeya}
    closeDetails={closeDetails}
    getDriversBranch={getDriversBranch}
    openDriverConfirm={openDriverConfirm}
    // openModalCommetaries={openModalCommetaries}
    // closeModalCommetaries={closeModalCommetaries}
    // modalCommentaries={modalCommentaries}
    transferOrder={transferOrder}
    // updateNotes={updateNotes}
    reasons={reasons}
    currentPage={currentPage}
    ordersTotal={ordersTotal} 
    filtersRef={filtersRef}
    loadingTable={loadingTable}
    onTableChange={(pagination, filters) => {
      const page = pagination.current;

      // Captura de filtros de busqueda
      const parsedFilters = {
        status: filters.status?.[0],
        orderType: filters.orderTypeName?.[0],
        branch: filtersRef.current.branch_name,
        ticket: filtersRef.current.ticket,
        customerName: filtersRef.current.customerName,
        phone: filtersRef.current.phone,
      };

      setCurrentPage(page);
      setTableFilters(parsedFilters);
      setLoadingTable(true);
      //console.log("Filtros reales enviados a API:", filtersRef);
      initialFetch(page, parsedFilters).finally(() => setLoadingTable(false));
    }}
    />
    </>
  );
};

export default Monitor;
